const module = { name: 'layouts/news.app', exports: {} }; const exports = module.exports;



// @ts-ignore
const checkDependencies = (moduleName, fn) => (fn?.log ?? console.debug)(`Initializing...${moduleName}`);


import { Fandango as Fandango_context } from 'require-core';

const { context: { config, req: { params: { hub } } } } = Fandango_context;


import { global_consts as global_consts_CookieNames } from 'require-core';

const { CookieNames } = global_consts_CookieNames;


import { Fandango_cookie as Fandango_cookie_set_setCookie } from 'require-core';

const { set: setCookie } = Fandango_cookie_set_setCookie;


import { Fandango_debugLog as debugLog } from 'require-core';



import { fd_url_manager as links } from 'require-core';



import { Fandango_xhr as xhr } from 'require-core';

function run() {
    checkDependencies(module.name, debugLog);
    setCookie(CookieNames.HUB, hub);
    xhr.init({
        tokenURI: links.napiAccountThemePreferences(),
        isMobile: false,
        timeout: 15000,
    });
    if (config?.share?.location) {
        debugLog.info(module.name, config.share.location);
    }
}
run();
export default module.exports;